<template>
  <div class="main-commitments padded-container">
    <div
      tag="section"
      class="align-items-center justify-content-center text-center"
      data-transition-effect
      data-transition-show
    >
      <h1 id="title_our-business" class="achievement-section-title">
        {{
          lang === 'KOR'
            ? main_setting?.main_business_info?.toc_title
            : main_setting?.main_business_info?.toc_title_e
        }}
      </h1>
    </div>

    <b-row
      tag="section"
      class="main-commitments2"
      data-transition-effect
      data-transition-show
      no-gutters
      align-v="center"
    >
      <b-col cols="10" offset="1" xl="5">
        <div class="d-block px-0 py-0 mb-3 mb-xl-0">
          <b-img
            v-if="main_setting?.main_business_info?.unsplash_path"
            :src="main_setting?.main_business_info?.unsplash_path"
            class="responsive-width"
          />
          <b-img
            v-else-if="main_setting?.main_business_info?.image_path"
            :src="$store.state.static_host + main_setting?.main_business_info?.image_path"
            class="responsive-width"
          />
          <b-img
            v-else
            src="/static_img/story_board/cover_images/sample_commitment.jpg"
            class="responsive-width"
          />
        </div>
      </b-col>

      <b-col cols="10" xl="5" offset="1" offset-xl="0" class="pl-xl-5">
        <div class="d-flex flex-column justify-content-between">
          <h1 class="fw-700 main-section-title mb-4 climate-title">
            {{
              lang === 'KOR'
                ? main_setting?.main_business_info?.title
                : main_setting?.main_business_info?.title_e
            }}
          </h1>
          <div class="main-section-header w-100 pt-0 pt-md-1 pt-lg-2 pt-xl-3 pt-xxl-4 mb-5">
            <div>
              <h5
                class="main-section-description fw-400 mb-0"
                v-html="
                  lang === 'KOR'
                    ? main_setting?.main_business_info?.content
                    : main_setting?.main_business_info?.content_e
                "
              ></h5>
            </div>
          </div>
        </div>

        <b-row>
          <b-col
            v-for="(item, index) in main_setting?.main_business_info?.sb_main_links"
            :key="index"
            cols="12"
            md="6"
            class="d-flex justify-content-center"
            :class="!isMediumScreen ? 'border-bottom' : ''"
          >
            <b-button
              :id="`title_our-business-${index + 1}`"
              variant="none"
              outline="none"
              class="w-100 mb-3"
              :class="{
                hovered: hoveredIndex === index,
                dimmed: hoveredIndex !== null && hoveredIndex !== index
              }"
              target="_blank"
              @mouseover="setHoveredIndex(index)"
              @mouseleave="setHoveredIndex(null)"
              @click="navigateLink(lang !== 'ENG' ? item.url : item.url_e)"
            >
              <h4>
                {{ lang === 'KOR' ? item?.title : item?.title_e }}
                <IconArrow class="arrow-icon" aria-label="Arrow icon indicating navigation" />
              </h4>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import IconArrow from '@/assets/icon/icon_arrow.vue';
import main_page_mixin from '@/mixins/main_page_mixin.js';

export default {
  name: 'MainCommitments',
  components: {
    IconArrow
  },
  mixins: [main_page_mixin],
  data() {
    return {
      isMediumScreen: window.innerWidth >= 768,
      observerTargets: [],
      mainpageIntersectionObserver: {},
      hoveredIndex: null
    };
  },
  computed: {
    ...mapState('story_board', ['main_setting']),
    ...mapState('report_list', ['lang'])
  },
  mounted() {
    this.observerTargets = this.$el.querySelectorAll('[data-transition-effect]');
    this.mainpageIntersectionObserver = new IntersectionObserver(
      (entries, observer) => {
        if (entries.length) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (entry.target.dataset.transitionEffect) {
                const transitionEffect = entry.target.dataset.transitionEffect;
                entry.target.classList.add(`transition-effect-${transitionEffect}`);
              }
              if (entry.target.dataset.transitionDuration) {
                const transitionDuration = entry.target.dataset.transitionDuration;
                entry.target.classList.add(`transition-duration-${transitionDuration}`);
              }
              if (entry.target.dataset.transitionDelay) {
                const transitionDelay = entry.target.dataset.transitionDelay;
                entry.target.classList.add(`transition-delay-${transitionDelay}`);
              }
              if (entry.target.hasAttribute('data-transition-show')) {
                if (entry.target.hasAttribute('data-transition-show-delay')) {
                  setTimeout(() => {
                    entry.target.classList.add('show');
                  }, Number(entry.target.dataset.transitionShowDelay));
                } else {
                  entry.target.classList.add('show');
                }
              }
              if (entry.target.hasAttribute('data-loaded')) {
                const elementLoadedTiming = entry.target.dataset.loaded;
                setTimeout(
                  () => {
                    entry.target.classList.add('loaded');
                  },
                  !elementLoadedTiming ? 0 : Number(elementLoadedTiming)
                );
              }
              observer.unobserve(entry.target);
            }
          });
        }
      },
      {
        threshold: 0.5
      }
    );
    if (this.observerTargets.length) {
      this.observerTargets.forEach(observerTarget => {
        this.mainpageIntersectionObserver.observe(observerTarget);
      });
    }
  },
  beforeDestroy() {
    if (this.mainpageIntersectionObserver) {
      this.mainpageIntersectionObserver.disconnect();
    }
  },
  methods: {
    setHoveredIndex(index) {
      this.hoveredIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-commitments {
  min-height: calc(100vh - 190px);
  margin-bottom: 100px;
}

.main-commitments2 {
  .main-section-description {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 500ms ease-in-out, transform 500ms ease-in-out;
    transition-delay: 300ms;
  }

  &.show {
    .main-section-description {
      opacity: 1;
      transform: translateY(0px);
    }

    .climate-title {
      animation: fill-animation 2s forwards;
    }
  }
}

@keyframes fill-animation {
  from {
    background-position: 100% 0;
  }

  to {
    background-position: 0 0;
  }
}

.btn {
  .arrow-icon,
  .arrow-icon2 {
    width: 0;
    transition: width 300ms ease-in-out;
  }

  :hover {
    .arrow-icon {
      width: 28px;
    }

    .arrow-icon2 {
      width: 20px;
    }
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01px;
  color: #111111;
}

.climate-title {
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: transparent;
  background: linear-gradient(to right, #111 50%, #66666650 50%);
  -webkit-background-clip: text;
  background-clip: text;
  background-size: 200% 100%;
  background-position: 100% 0;
}

.climate-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: white;
  z-index: -1;
}

.responsive-width {
  width: 100%;
}
</style>
